import React from 'react';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, subtitle, action }) => (
  <div className="flex items-center justify-between mb-3">
    <div>
      <h2 className="section-heading">{title}</h2>
      {subtitle && <p className="section-sub">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export default SectionHeader;
